/** Sans choix explicite, conserve le réglage historique du type de parcours. */
export function operationProgressiveEnabled(
  parcoursType: string | null | undefined,
  enabled: boolean | null | undefined,
): boolean {
  return enabled ?? parcoursType !== "digital";
}
